import React from "react";
import { useTable } from "react-table";

function Table({ columns, data, title }) {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data });

  const hasNestedHeaders = columns.some(col => col.columns && col.columns.length > 0);

  return (
    <div>
      {title ? <h2 style={{ margin: "30px auto",textAlign: "center" }}>{title}</h2> : ""}
      <table
        {...getTableProps()}
        style={{
          borderSpacing: 0,
          borderCollapse: "collapse",
          border: "1px solid black",
          margin: "auto",
          width: "100%",
        }}
      >
        <thead>
          <tr>
            {columns.map((col, colIndex) => (
              col.columns ? (
                // Parent column with children
                <th
                  key={col.Header}
                  colSpan={col.columns.length}
                  rowSpan={1}
                  style={{
                    margin: 0,
                    padding: "1rem",
                    borderBottom: "1px solid black",
                    borderRight:
                      colIndex === columns.length - 1
                        ? "0"
                        : "1px solid black",
                    verticalAlign: "middle",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {col.Header}
                </th>
              ) : (
                // Single column without children
                <th
                  key={col.Header}
                  colSpan={1}
                  rowSpan={hasNestedHeaders ? 2 : 1}
                  style={{
                    margin: 0,
                    padding: "1rem",
                    borderBottom: "2px solid black",
                    borderRight:
                      colIndex === columns.length - 1
                        ? "0"
                        : "1px solid black",
                    verticalAlign: "middle",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {col.Header}
                </th>
              )
            ))}
          </tr>
          {hasNestedHeaders && (
            <tr>
              {columns.map((col) =>
                col.columns ? (
                  col.columns.map((subCol, subColIndex, arr) => (
                    <th
                      key={subCol.Header}
                      style={{
                        margin: 0,
                        padding: "1rem",
                        borderBottom: "2px solid black",
                        borderRight:
                          subColIndex === arr.length - 1
                            ? "1px solid black"
                            : "1px solid black",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      {subCol.Header}
                    </th>
                  ))
                ) : null
              )}
            </tr>
          )}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr
                {...row.getRowProps()}
                style={{
                  margin: 0,
                  padding: "0.5rem",
                }}
              >
  
                {row.cells.map((cell, cellIndex) => (
                  <td
                    {...cell.getCellProps()}
                    style={{
                      margin: 0,
                      padding: "0.5rem",
                      borderBottom: "1px solid black",
                      borderRight:
                        cellIndex === row.cells.length - 1
                          ? "0"
                          : "1px solid black",
                    }}
                  >
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
